<template>
    <div class="People">
        <div class="row record-section-row">
            <div class="col">
                <h4>Caregivers:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="StrongFamilies/VolunteerFamilies/Contacts/GetContacts"
                                           :get-payload="{FamilyId: RecordData.Id, ContactCategory: 'Caregiver'}"
                                           add-edit-endpoint="StrongFamilies/VolunteerFamilies/Contacts/AddEditContact"
                                           :add-edit-payload="{ChartID: RecordData.Id, ContactCategory: 'Caregiver'}"
                                           delete-endpoint="StrongFamilies/VolunteerFamilies/Contacts/DeleteContact"
                                           :require-dob="true"
                                           contact-category="Caregiver"
                                           :relationship-options="FamilyRelationOptions"
                                           relationship-label="Host Home"
                                           :display-age="true"
                                           :include-pnw-family-tracking="false"
                                           :display-relationship="true" 
                                           :is-strong-family-contactable="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Family Members:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="StrongFamilies/VolunteerFamilies/Contacts/GetContacts"
                                           :get-payload="{FamilyId: RecordData.Id, ContactCategory: 'Family Member'}"
                                           add-edit-endpoint="StrongFamilies/VolunteerFamilies/Contacts/AddEditContact"
                                           :add-edit-payload="{ChartID: RecordData.Id, ContactCategory: 'Family Member'}"
                                           delete-endpoint="StrongFamilies/VolunteerFamilies/Contacts/DeleteContact"
                                           :require-dob="true"
                                           contact-category="Family Member"
                                           :relationship-options="FamilyRelationOptions"
                                           relationship-label="Host Parents"
                                           :display-age="true"
                                           :include-pnw-family-tracking="false"
                                           :display-relationship="true" />
                </div>
            </div>
        </div>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);

    //import components
    import ContactDisplayAndEdit from '../../../../Core/ItemEditors/ContactDisplayAndEdit.vue';

    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';


    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            GetProgramService(value) {
                if (value.length > 0) {
                    return value[0].ProgramService.Name;
                }
                else return "";
                
            }
        },
        components: {
            ContactDisplayAndEdit,
            EditMode
        },
        mounted() {

        },
        computed: {
            FamilyRelationOptions: function () {
                return this.$store.state.Options.FamilyRelations;
            },
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.FamilyRecordData.FamilyProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>

</style>